import Autosave from 'stimulus-rails-autosave'
import TextareaAutogrow from 'stimulus-textarea-autogrow'
import PasswordVisibility from '@stimulus-components/password-visibility'

import { stimulus } from '~/init'

stimulus.register('autosave', Autosave)
stimulus.register('textarea-autogrow', TextareaAutogrow)
stimulus.register('password-visibility', PasswordVisibility)

import.meta.glob('./**/*_controller.js', { eager: true })
